export interface UserCode {
  id: string;
  code: string;
  status: CodeStatus;
  flipPrice: number;
  mainTimer: number;
  price: number;
  startPrice: number;
  minPrice?: number;
  product: {
    name: string;
    imageUrl: string;
    brandName: string;
    brandLogoUrl: string;
    images: { url: string, thumb:string }[];
  };
}

export enum CodeStatus {
  new = 'new',
  won = 'won',
  used = 'used',
  started = 'started',
  pending = 'pending',
  withdrawn = 'withdrawn',
  on_reel = 'on_reel',
  back = 'back',
  reservation = 'reservation',
  return = 'return',
  expired = 'expired',
}

